import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

export const gradingAPI = {
  getGradingSystem: async () => {
    const response = await apiClient.get("/teacher/grading-system");
    return unwrapApiResponse(response);
  },
};
